import {DetailsFieldsSection} from '@/components/ui/details-atoms/DetailsAtoms'
import styled, {css} from 'styled-components'

export const StyledTreatmentRequestDetailsNotesSection = styled(DetailsFieldsSection)(
    ({theme: {palette}}) => css`
        border-top: 1px solid ${palette.neutral['200']};
        border-bottom: none;
    `
)
